// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3p4-8","footer":"ModalFilter_footer__2Nryg"};